// LIBRARIES

import styled, { css } from "styled-components";

//MISC

import {
  BORDER_RADIUS,
  COLORS,
  MARGIN,
  DEVICE_TYPE,
} from "constants/variables";
import { CardType } from "./HomePageCustomCardModel";

//helpers

const getAdditionalStyles = (type) => {
  switch (type) {
    case CardType.Content:
      return css`
        @media (max-width: ${DEVICE_TYPE.tablet}) {
          height: auto;
        }
      `;
    case CardType.Title:
      return css`
        @media (max-width: ${DEVICE_TYPE.tablet}) {
          height: auto;
        }
      `;
    case CardType.Image:
      return css`
        @media (max-width: ${DEVICE_TYPE.tablet}) {
          height: 100%;
        }
      `;
    default:
      return "";
  }
};
export const CardContainer = styled.div<{
  colSpan: number;
  rowSpan: number;
  type: CardType;
}>`
  grid-column: span ${({ colSpan }) => colSpan};
  grid-row: span ${({ rowSpan }) => rowSpan};
  border-radius: ${BORDER_RADIUS.radius21};
  overflow: hidden;
  background-color: ${({ type }) =>
    type === CardType.Image ? "transparent" : COLORS.FaluRed};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ type }) => (type === CardType.Image ? "0px" : MARGIN.max40)};
  position: relative;
  height: auto;
  ${({ type }) => getAdditionalStyles(type)}
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
    height: auto;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardTitle = styled.div`
  text-align: center;
  max-width: 346px;
`;

export const CardContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.fix24};
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max4};
  height: auto;
`;

export const CardIllustration = styled.img`
  position: absolute;
  top: -107px;
  right: -107px;
  width: 255px;
  height: 255px;
`;
